import { MC_OPS_INIT_STATE, SET_MC_OPS_META, SET_MC_OPS_STATE } from "./types";

export const mcOpsDashboardReducer = (state = MC_OPS_INIT_STATE, action) => {
  switch (action.type) {
    case SET_MC_OPS_STATE:
      return { ...state, data: action.payload };
    case SET_MC_OPS_META:
      return { ...state, meta: { ...state.meta, ...action.payload } };
    default:
      return state;
  }
};
